import React, { useEffect } from 'react';

const OptinMonsterScript = () => {
    useEffect(() => {
        // Function to dynamically load the OptinMonster script
        const loadOptinMonsterScript = (document, user, account) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://a.omappapi.com/app/js/api.min.js';
            script.async = true;
            script.dataset.user = user;
            script.dataset.account = account;
            document.getElementsByTagName('head')[0].appendChild(script);
        };

        // Call the function with the user and account IDs
        loadOptinMonsterScript(document, '154199', '167935');
    }, []);

    return null;
};

export default OptinMonsterScript;